import { formatStatisticNumber } from '@/utils/number-format';

export function triggerCsvDownload(res: any, fallbackName: string) {
  const csv = res.body ?? '';
  const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8' });
  const cd = res.headers?.get('content-disposition');
  const filename = extractFilename(cd) ?? fallbackName;
  downloadBlob(blob, filename);
}

export function quoteCsvField(value: string): string {
  return `"${value.replace(/"/g, '""')}"`;
}

// Wraps a value in an Excel text-formula (="…") so German Excel never guesses it's a date/number.
export function excelTextGuard(value: string): string {
  return `="${value}"`;
}

// German-locale numeric format (comma decimal) to match a semicolon-delimited CSV. Rounds via
// formatStatisticNumber first so e.g. a running float sum (1234.5000000000002) doesn't leak its
// binary-float tail into the export — same rounding as the chart's bar/axis labels.
export function germanExcelNumber(value: number): string {
  return formatStatisticNumber(value).replace('.', ',');
}

export function downloadDelimitedCsv(rows: string[][], filename: string, delimiter = ';'): void {
  const csv = '\uFEFF' + rows.map(row => row.join(delimiter)).join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, filename);
}

export function downloadBlob(blob: Blob, filename: string) {
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}

function extractFilename(contentDisposition: string | null): string | null {
  if (!contentDisposition) return null;
  const match = /filename\*=(?:UTF-8''|)([^;]+)|filename="([^"]+)"/i.exec(contentDisposition);
  const raw = match?.[1] ?? match?.[2];
  return raw ? decodeURIComponent(raw.replace(/^"|"$|;/g, '')) : null;
}
